module.exports = __webpack_public_path__ + "img/send-fff.09c92f92.svg";